import { render, staticRenderFns } from "./menupermissions.vue?vue&type=template&id=1ec958d5&scoped=true&"
import script from "./menupermissions.vue?vue&type=script&lang=js&"
export * from "./menupermissions.vue?vue&type=script&lang=js&"
import style0 from "./menupermissions.vue?vue&type=style&index=0&id=1ec958d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec958d5",
  null
  
)

export default component.exports